module.exports = __webpack_public_path__ + "b984adab36365af59ae34fb0a905e91f.png";